const config = {
  contractAddress: "KT1UZLPPZmZpbpAdimNhHb9QfmKTcEWUrRxz",
};

export default config;
